import React, { useState, useEffect, Fragment } from "react";
import { Container, Spinner, Row, Col, Accordion} from "react-bootstrap";
import { useParams } from "react-router-dom";
import { useUser } from "../context/UserContext";
import ProblemService from "../services/problem.service";
import SubProblem from "../components/SubProblem";
import AsaService from "../services/asa.service";

const Project = () => {

   const { problemtypeid } = useParams();
   const [project, setProject] = useState([]);
   const [loading, setLoading] = useState([]);
   const [errorMsg, setErrorMsg] = useState("");
   const [errorAsaMsg, setErrorAsaMsg] = useState("");
   const { asaData } = useUser();

   useEffect(() => { 
      const loadProject = async (pbtypeid, asadata) => { 
        try{
          setLoading(true); 
          const response = await ProblemService.getProject(pbtypeid);
          setProject(response.data); 
          if(asaData && asaData.step_number==1){
            const asaresp = await AsaService.sendTaskCompletion(asaData);
            console.log("ASA Response: ", asaresp)
          }
          setLoading(false); 
        }
        catch(error){
          setLoading(false);
          console.log("Project Error: ", error);
          setErrorMsg('Oops! Something went wrong');
        }
      }
      loadProject(problemtypeid, asaData);
    }, []);  


    if (loading) {
      return (
        <Container className="p-5">
          <Row className="m-3">
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </Row>
        </Container>
      );
    }

    if (errorMsg){
      return (
        <Container className="p-5">
          <Row className="m-3">
            <span className="text-danger">{errorMsg}</span>
          </Row>
        </Container>
      );

    }

    const megapb = project.find(row => row.megapb === 1);
    
    const completed = project.filter((item)=> {if(item.solutionid) return item});
    const notStarted = project.filter((item)=> {if(!item.solutionid && item.ordernum) return item});
    const currTask = notStarted.shift();
    var compCurrent = completed;
    
    if(currTask){
      compCurrent = completed.concat(currTask);
    }
  

    const primgsrc = `/images/challenges/${megapb.problemtypename}.png`;
   

    return( 
      <Fragment>

         <div className="bg-light mx-0 my-0 p-5 rounded-lg">
          <Row>
            <Col className="col-md-3">
               <img className="img-fluid"
                     src={primgsrc}
                     height="100%"
                     width = "100%"
                     alt="Project"
               />
            </Col>
            <Col className="col-md-9 ps-0 pt-3">
            <h1 className="display-3"> 
               {megapb.problemtypename}
            </h1>
            <p> {megapb.problemtypedesc} </p>
            </Col>
         </Row>
        </div> 

        <Container className = "mt-5 mb-5">
         <Accordion>
         {
                       compCurrent.map((item) => ( 
                        
                          <SubProblem problem={item}/> 
                           
                       )) 

        }
        {
                       notStarted.map((item) => (               
                           <>
                              <Accordion.Item eventKey={item.problemid}>
                                <Accordion.Header> <span style={{color: '#bbbbbb'}}> Task #{item.ordernum}: {item.title} </span>
                                </Accordion.Header>
                                <Accordion.Body className="p-5">
                                  You need to complete previous tasks
                                </Accordion.Body>
                              </Accordion.Item>
                           </>                          
                       )) 

        }
         </Accordion>
          
        </Container>

      </Fragment>
 
        
    );
};
  
  export default Project;